'use client';

import type { ReactElement } from 'react';
import { NavbarProfileErrorAction } from './NavbarProfileErrorAction';
import { NavbarProfileReadyAction } from './NavbarProfileReadyAction';

interface NavbarProfileActionProps {
  authError: boolean;
  isMobile: boolean;
  onProfileClick: () => void;
  profileImageSrc?: string;
}

interface ProfileActionMobileInput {
  isMobile: boolean;
}

function getProfileImageSize({
  isMobile,
}: ProfileActionMobileInput): number {
  return isMobile ? 41 : 48;
}

function getProfileChevronSize({
  isMobile,
}: ProfileActionMobileInput): number {
  return isMobile ? 16 : 20;
}

export function NavbarProfileAction({
  authError,
  isMobile,
  onProfileClick,
  profileImageSrc,
}: NavbarProfileActionProps): ReactElement {
  const profileImageSize = getProfileImageSize({ isMobile });

  if (authError) {
    return (
      <NavbarProfileErrorAction
        profileImageSize={profileImageSize}
        profileImageSrc={profileImageSrc}
      />
    );
  }

  return (
    <NavbarProfileReadyAction
      chevronSize={getProfileChevronSize({ isMobile })}
      onProfileClick={onProfileClick}
      profileImageSize={profileImageSize}
      profileImageSrc={profileImageSrc}
    />
  );
}
